import { endSession } from '../../FORMS/application/readerSetup/session';
import { session, socket } from 'lib_ui-services';

// Allow mocking of dependencies for testing purposes, but use the real implementations in production.
const _private = {
    endSession,
    socket,
    session
};
export default {
    verb: 'doingRemove',
    namespace: 'security',
    relation: 'profile',
    description: 'Log out the current user',
    priority: 10,
    logic,
    _private
};

async function logic() {
    await _private.endSession();
    _private.socket.disconnect();
    await _private.session.logout();
}
